export default {
    path: 'everyday_statistics',
    component: () => import(/* webpackChunkName: "everyday_statistics" */ '@/pages/everyday/statistics'),
   
	meta: {title:'每日统计',cate:'查询中心'}
}